import styled from '@emotion/styled';
import * as c from '@identity/constants';
import * as s from '@identity/spacing';

export const Wrapper = styled.article`
  ${({ space }) => space && s.spacing(space)};

  padding: 45px 0;

  ${c.TABLET} {
    padding: 60px 0;
  }
`;
